{
  "color": {
    "violet": "#6D5EF8",
    "cyan": "#22D3EE",
    "graphite": "#0B1020",
    "paper": "#FCFBF8",
    "mist": "#F2F0EC",
    "ink": "#17151D",
    "muted": "#6F6A78",
    "success": "#1B8A6B",
    "warning": "#B46B20",
    "danger": "#C44D5F"
  },
  "space": { "1": "0.25rem", "2": "0.5rem", "3": "0.75rem", "4": "1rem", "5": "1.25rem", "6": "1.5rem", "8": "2rem", "10": "2.5rem", "12": "3rem", "16": "4rem" },
  "radius": { "sm": "0.625rem", "md": "1rem", "lg": "1.5rem", "pill": "999px" },
  "shadow": { "soft": "0 10px 30px rgba(23, 21, 29, 0.08)", "lift": "0 20px 60px rgba(23, 21, 29, 0.14)" },
  "type": { "display": "Newsreader, Iowan Old Style, Baskerville, Georgia, serif", "ui": "Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif" },
  "motion": { "fast": "150ms", "standard": "220ms", "ease": "cubic-bezier(0.22, 1, 0.36, 1)" },
  "breakpoint": { "mobile": "360px", "tablet": "768px", "desktop": "1024px", "wide": "1440px" }
}
